import { __assign } from 'tslib';
import { animations } from '../../motion/features/animations.js';
import { gestureAnimations } from '../../motion/features/gestures.js';
import { createDomVisualElement } from './create-visual-element.js';
/**
 * @public
 */

var domAnimation = __assign(__assign({
  renderer: createDomVisualElement
}, animations), gestureAnimations);

export { domAnimation };